<template>
  <div class="settings-container">
    <div class="page-header">
      <h3>系统设置</h3>
    </div>
    
    <div class="content-wrapper">
      <el-card>
        <div slot="header" class="clearfix">
          <span>系统参数设置</span>
        </div>
        
        <el-form ref="settingsForm" :model="settingsForm" label-width="150px">
          <el-form-item label="系统名称">
            <el-input v-model="settingsForm.systemName" placeholder="请输入系统名称" />
          </el-form-item>
          
          <el-form-item label="系统Logo">
            <el-upload
              class="upload-demo"
              action="#"
              :before-upload="beforeUpload"
              :show-file-list="false"
              :on-success="handleUploadSuccess"
            >
              <img v-if="settingsForm.logoUrl" :src="settingsForm.logoUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          
          <el-form-item label="系统主题色">
            <el-color-picker v-model="settingsForm.themeColor" />
          </el-form-item>
          
          <el-form-item label="是否启用验证码">
            <el-switch v-model="settingsForm.enableCaptcha" />
          </el-form-item>
          
          <el-form-item label="会话超时时间(分钟)">
            <el-input-number v-model="settingsForm.sessionTimeout" :min="5" :max="120" />
          </el-form-item>
          
          <el-form-item label="日志记录级别">
            <el-select v-model="settingsForm.logLevel" placeholder="请选择日志级别">
              <el-option label="DEBUG" value="debug" />
              <el-option label="INFO" value="info" />
              <el-option label="WARN" value="warn" />
              <el-option label="ERROR" value="error" />
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" @click="handleSubmit">保存设置</el-button>
            <el-button @click="handleCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data() {
    return {
      settingsForm: {
        systemName: '管理系统',
        logoUrl: '',
        themeColor: '#409EFF',
        enableCaptcha: true,
        sessionTimeout: 30,
        logLevel: 'info'
      }
    }
  },
  methods: {
    beforeUpload(file) {
      // 这里应该有文件类型和大小的检查
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('请上传图片文件')
        return false
      }
      
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB')
        return false
      }
      
      // 模拟上传成功
      setTimeout(() => {
        this.settingsForm.logoUrl = URL.createObjectURL(file)
      }, 100)
      
      return false // 阻止默认上传行为
    },
    
    // eslint-disable-next-line no-unused-vars
    handleUploadSuccess(response, file, fileList) {
      // 实际项目中，这里应该处理上传成功的逻辑
      this.$message.success('Logo上传成功')
    },
    
    handleSubmit() {
      // 模拟提交设置
      this.$confirm('确定要保存这些设置吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 这里应该调用API保存设置
        // await saveSettings(this.settingsForm)
        
        this.$message.success('设置保存成功')
      }).catch(() => {
        this.$message.info('已取消保存')
      })
    },
    
    handleCancel() {
      this.$router.push('/home')
    }
  }
}
</script>

<style scoped>
.settings-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h3 {
  color: #303133;
  font-size: 18px;
}

.content-wrapper {
  margin-top: 20px;
}

.el-form {
  padding: 20px 0;
}

.el-form-item {
  margin-bottom: 25px;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}
</style>